import Vue from "vue";
import Router from "vue-router";
// import report_query_route from "./report.js" //g前端页面路由
const Home = (resolve) => require(["../components/common/Home.vue"], resolve);
const Home1 = (resolve) =>
    require(["../components/common/dy/Home.vue"], resolve);
const Nav = (resolve) => require(["../components/common/Nav.vue"], resolve);
Vue.use(Router);

var myrouter = {
    routes: [
        {
            path: "/rqmod",
            name: "system",
            title: "管控系统",
            icon: "iconfont icon-anleibiefenzu",
            menu: false,
            nav: true,
            redirect: "/bigscreen",
            component: (resolve) =>
                require(["@/components/common/V1920_1080/system.vue"], resolve),
            children: [
                // {
                //     path: '/rqmod',
                //     name: 'index',
                //     title: "燃气模块",
                //     icon: "iconfont icon-anleibiefenzu",
                //     menu: false,
                //     nav: true,
                //     component: resolve => require(['@/components/views/dpi1920_1080/rqmod.vue'], resolve),
                //
                // },
                // {
                //     path: '/rlmod',
                //     name: 'index',
                //     title: "热力模块",
                //     icon: "iconfont icon-anleibiefenzu",
                //     menu: false,
                //     nav: true,
                //     component: resolve => require(['@/components/views/dpi1920_1080/rlmod.vue'], resolve),
                //
                // },
                {
                    path: "/bigscreen",
                    name: "index",
                    title: "场站专题",
                    icon: "iconfont icon-anleibiefenzu",
                    menu: false,
                    nav: true,
                    component: (resolve) =>
                        require([
                            "@/components/views/dpi1920_1080/statisticalAnalysis.vue",
                        ], resolve),
                },
            ],
        },
        {
            path: "/",
            name: "Home",
            component: Home1,

            redirect: "/entrance",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "/entrance",
                    icon: "iconfont icon-Cockpit",
                    title: "",
                    component: (resolve) =>
                        require(["../components/dy/entrance.vue"], resolve),
                    isnav: false,
                },

                {
                    path: "/rqmod",
                    name: "rqmod",
                    selected: false,
                    icon: "@/../static/img/dy/2.png",
                    iconEd: "@/../static/img/dy/6.png",
                    id: "1",
                    level: 1,
                    isnav: false,
                    redirect: "/bigscreen",
                    title: "监管大屏",
                    component: Nav,
                    children: [],
                },
                {
                    path: "/homepage",
                    name: "homepage",
                    icon: "@/../static/img/dy/3.png",
                    iconEd: "@/../static/img/dy/7.png",
                    id: "2",
                    level: 1,
                    isnav: true,
                    selected: false,
                    redirect: "/homepage",
                    title: "燃气监管",
                    component: Nav,
                    children: [
                        {
                            path: "/homepage",
                            name: "Homepage",
                            title: "首页",
                            icon: "el-icon-menu",
                            id: "180",
                            isNav: true,
                            component: (resolve) =>
                                require([
                                    "@/views/homePage/index.vue",
                                ], resolve),
                        },
                        {
                            path: "/rqyzt",
                            name: "rqyzt",
                            icon: "el-icon-menu",
                            id: "33",
                            title: "燃气监管一张图",
                            component: (resolve) =>
                                require([
                                    "../components/dy/rqyzt1.vue",
                                ], resolve),
                        },
                        {
                            path: "/EIFR",
                            name: "EIFR",
                            title: "企业信息填报审核",
                            icon: "el-icon-menu",
                            id: "106",
                            component: Nav,
                            children: [
                                {
                                    path: "/submitrecords",
                                    name: "submitrecords",
                                    icon: "el-icon-c-scale-to-original",
                                    isNav: true,
                                    id: "53",
                                    title: "填报记录审核",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/submitrecords.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/qyxx",
                                //     title: "企业信息",
                                //     name: "qyxx",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "108",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/enterpriseInformationLedger.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/qyry",
                                //     title: "企业人员",
                                //     name: "qyry",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "109",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/enterprisePersonnelaccount.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/gdtrq",
                                //     title: "管道天然气",
                                //     name: "gdtrq",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "110",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/submitRecords/gdtrq.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/yhsyq",
                                //     title: "液化石油气",
                                //     name: "yhsyq",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "111",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/submitRecords/yhsyq.vue",
                                //         ], resolve),
                                // },
                                // //   {
                                // //       path: '/rgmq',
                                // //       title: "人工煤气",
                                // //       name: 'rgmq',
                                // //       icon:"el-icon-menu",
                                // //       isNav:true,
                                // //       id:"112",
                                // //       component: resolve => require(['../components/dy/submitRecords/rgmq.vue'], resolve),
                                //
                                // //     },
                                // {
                                //     path: "/trqjqz",
                                //     title: "汽车加气站",
                                //     name: "trqjqz",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "113",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/submitRecords/trqjqz.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/qygql",
                                //     title: "企业购气量",
                                //     name: "qygql",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "114",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/submitRecords/qygql.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/qycqss",
                                //     title: "企业储气设施",
                                //     name: "qycqss",
                                //     icon: "el-icon-menu",
                                //     isNav: true,
                                //     id: "115",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/submitRecords/qycqss.vue",
                                //         ], resolve),
                                // },
                                // // {
                                // //     path: "/fjmrqyh",
                                // //     title: "非居民燃气用户",
                                // //     name: "fjmrqyh",
                                // //     icon: "el-icon-menu",
                                // //     isNav: true,
                                // //     id: "116",
                                // //     component: (resolve) =>
                                // //         require([
                                // //             "../components/dy/submitRecords/fjmrqyh.vue",
                                // //         ], resolve),
                                // // },
                            ],
                        },
                        {
                            path: "/residentGasUsers",
                            name: "residentGasUsers",
                            title: "告警管理",
                            icon: "el-icon-menu",
                            id: "199",
                            component: Nav,
                            children: [
                                {
                                    path: "/thresholdMonitor",
                                    name: "thresholdMonitor",
                                    icon: "el-icon-menu",
                                    id: "48",
                                    title: "告警阈值监控",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/alarmThreshold/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/systemAlarmList",
                                    name: "systemAlarmList",
                                    icon: "el-icon-menu",
                                    id: "200",
                                    title: "系统告警清单",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/alarmThreshold1/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/videoAlert",
                                    name: "videoAlert",
                                    icon: "el-icon-menu",
                                    id: "197",
                                    title: "视频监控告警清单",
                                    component: (resolve) =>
                                        require([
                                            "../views/videoAlert/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/al",
                                    name: "al",
                                    icon: "el-icon-menu",
                                    id: "32",
                                    title: "企业上报告警清单",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/al.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/GISbj",
                                //     name: "GISbj",
                                //     icon: "el-icon-menu",
                                //     id: "56",
                                //     title: "GIS燃气综合报警",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/GISbj1.vue",
                                //         ], resolve),
                                // },
                                // {
                                //     path: "/alarmlimit",
                                //     name: "alarmlimit",
                                //     icon: "el-icon-menu",
                                //     id: "57",
                                //     title: "报警限值设置",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/alarmlimit.vue",
                                //         ], resolve),
                                // },
                            ],
                        },
                        {
                            path: "/gsm",
                            name: "gsm",
                            icon: "el-icon-menu",
                            id: "8",
                            isnav: true,
                            title: "燃气安全监测",
                            component: Nav,
                            children: [
                                {
                                    path: "/srtm",
                                    name: "srtm",
                                    icon: "el-icon-menu",
                                    id: "18",
                                    title: "场站实时监测",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/srtm.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/shd",
                                    name: "shd",
                                    icon: "el-icon-menu",
                                    id: "19",
                                    title: "场站历史数据",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/shd.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/shc",
                                    name: "shc",
                                    icon: "el-icon-menu",
                                    id: "20",
                                    title: "场站历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/shc.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/tyxss",
                                    name: "tyxss",
                                    icon: "el-icon-menu",
                                    id: "153",
                                    title: "调压柜/箱实时监测",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/pressDevice/monitor.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/tyxls",
                                    name: "tyxls",
                                    icon: "el-icon-menu",
                                    id: "154",
                                    title: "调压柜/箱历史数据",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/pressDevice/historyData.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/tyxlsqx",
                                    name: "tyxlsqx",
                                    icon: "el-icon-menu",
                                    id: "155",
                                    title: "调压柜/箱历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/pressDevice/historyLine.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/gasStorageMonitor",
                                    name: "gasStorageMonitor",
                                    icon: "el-icon-menu",
                                    id: "170",
                                    title: "储气罐设施实时监测",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/gasStorage/monitor.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/gasStorageHistoryData",
                                    name: "gasStorageHistoryData",
                                    icon: "el-icon-menu",
                                    id: "171",
                                    title: "储气罐设施历史数据",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/gasStorage/historyData.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/gasStorageHistoryLine",
                                    name: "gasStorageHistoryLine",
                                    icon: "el-icon-menu",
                                    id: "172",
                                    title: "储气罐设施历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "@/views/gasSafetyManagement/gasStorage/historyLine.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/rtmcvw",
                                    name: "rtmcvw",
                                    icon: "el-icon-menu",
                                    id: "21",
                                    title: "阀井实时监测",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/rtmcvw.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/hdovw",
                                    name: "hdovw",
                                    icon: "el-icon-menu",
                                    id: "22",
                                    title: "阀井历史数据",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/hdovw.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/vwhc",
                                    name: "vwhc",
                                    icon: "el-icon-menu",
                                    id: "23",
                                    title: "阀井历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/vwhc.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/rtmidp",
                                    name: "rtmidp",
                                    icon: "el-icon-menu",
                                    id: "26",
                                    title: "密集场所实时监测",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/rtmidp.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/hdodp",
                                    name: "hdodp",
                                    icon: "el-icon-menu",
                                    id: "24",
                                    title: "密集场所历史数据",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/hdodp.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/hcodp",
                                    name: "hcodp",
                                    icon: "el-icon-menu",
                                    id: "25",
                                    title: "密集场所历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/hcodp.vue",
                                        ], resolve),
                                },

                                {
                                    path: "/rtmoas",
                                    name: "rtmoas",
                                    icon: "el-icon-menu",
                                    id: "27",
                                    title: "相邻空间实时监测",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/rtmoas.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/hdoas",
                                    name: "hdoas",
                                    icon: "el-icon-menu",
                                    id: "28",
                                    title: "相邻空间历史数据",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/hdoas.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/ashc",
                                    name: "ashc",
                                    icon: "el-icon-menu",
                                    id: "29",
                                    title: "相邻空间历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/ashc.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/rtmoe1",
                                    name: "rtmoe1",
                                    icon: "el-icon-menu",
                                    id: "140",
                                    title: "设备实时监测",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/rtmoe1.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/ehd1",
                                    name: "ehd1",
                                    icon: "el-icon-menu",
                                    id: "141",
                                    title: "设备历史数据",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/ehd1.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/grsblsqx",
                                    name: "grsblsqx",
                                    icon: "el-icon-menu",
                                    id: "143",
                                    title: "设备历史曲线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/rqsblsqx.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/gasSafetyManagement",
                            name: "gasSafetyManagement",
                            title: "燃气安全管理",
                            icon: "el-icon-menu",
                            id: "159",
                            component: Nav,
                            children: [
                                {
                                    path: "/supervision",
                                    name: "Supervision",
                                    title: "监督检查",
                                    icon: "el-icon-menu",
                                    id: "181",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/supervision/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/dangerManagement",
                                    name: "dangerManagement",
                                    icon: "el-icon-menu",
                                    id: "161",
                                    title: "钢瓶巡检隐患管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/gasSafetyManagement/dangerManagement",
                                        ], resolve),
                                },
                                {
                                    path: "/dangerReport",
                                    name: "dangerReport",
                                    title: "隐患上报",
                                    icon: "el-icon-menu",
                                    id: "193",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/dangerReport/index.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/hder",
                                //     name: "hder",
                                //     icon: "el-icon-menu",
                                //     id: "31",
                                //     title: "隐患事件记录",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/hder.vue",
                                //         ], resolve),
                                // },
                                {
                                    path: "/accidentmanagement",
                                    name: "accidentmanagement",
                                    icon: "el-icon-menu",
                                    id: "174",
                                    title: "事故管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/news/accidentmanagement",
                                        ], resolve),
                                },
                                {
                                    path: "/patrolpoint",
                                    name: "patrolpoint",
                                    icon: "el-icon-menu",
                                    id: "46",
                                    title: "巡检点信息管理",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/patrolpoint.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/inspectionManagement",
                                //     name: "inspectionManagement",
                                //     icon: "el-icon-menu",
                                //     id: "165",
                                //     title: "企业巡检管理",
                                //     component: (resolve) =>
                                //         require([
                                //             "../views/inspectionManagement",
                                //         ], resolve),
                                // },
                                {
                                    path: "/routineInspection",
                                    name: "RoutineInspection",
                                    title: "日常巡检管理",
                                    icon: "el-icon-menu",
                                    id: "191",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/routineInspection/index.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/gaspipeline",
                                //     name: "gaspipeline",
                                //     icon: "el-icon-menu",
                                //     id: "59",
                                //     title: "燃气管线巡检",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/gaspipeline.vue",
                                //         ], resolve),
                                // },
                                {
                                    path: "/enterManagement",
                                    name: "enterManagement",
                                    icon: "el-icon-menu",
                                    id: "201",
                                    title: "随瓶安检管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/gasSafetyManagement/enterManagement",
                                        ], resolve),
                                },
                                {
                                    path: "/csr",
                                    name: "csr",
                                    icon: "el-icon-menu",
                                    id: "30",
                                    title: "施工工地记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/rqcsr.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/sidestationRecord",
                                    name: "sidestationRecord",
                                    icon: "el-icon-menu",
                                    id: "183",
                                    title: "工地旁站记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/sidestationRecord.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/userSecuritycheck",
                                //     name: "userSecuritycheck",
                                //     icon: "el-icon-menu",
                                //     id: "58",
                                //     title: "用户安检",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/userSecuritycheck.vue",
                                //         ], resolve),
                                // },
                                {
                                    path: "/homeInspection",
                                    name: "HomeInspection",
                                    title: "入户安检",
                                    icon: "el-icon-menu",
                                    id: "184",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/homeInspection/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/dangerSource",
                                    name: "DangerSource",
                                    title: "危险源管理",
                                    icon: "el-icon-menu",
                                    id: "195",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/dangerSource/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/projectSupervision",
                                    name: "ProjectSupervision",
                                    title: "工程建设监管",
                                    icon: "el-icon-menu",
                                    id: "185",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/projectSupervision/index.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/complaintReport",
                            name: "complaintReport",
                            title: "客户投诉管理",
                            icon: "el-icon-menu",
                            id: "192",
                            isNav: true,
                            component: (resolve) =>
                                require([
                                    "@/views/complaintReport/index.vue",
                                ], resolve),
                        },
                        {
                            path: "/enterpriseAlarm",
                            name: "enterpriseAlarm",
                            title: "企业告警通知",
                            icon: "el-icon-menu",
                            // id: "192",
                            isNav: false,
                            component: (resolve) =>
                                require([
                                    "@/views/homePage/enterpriseAlarmNotifi",
                                ], resolve),
                        },
                        {
                            path: "/businessData",
                            name: "businessData",
                            title: "业务数据更新",
                            icon: "el-icon-menu",
                            // id: "192",
                            isNav: false,
                            component: (resolve) =>
                                require([
                                    "@/views/homePage/businessData",
                                ], resolve),
                        },
                        {
                            path: "/gasOperationManagement",
                            name: "gasOperationManagement",
                            title: "燃气运营管理",
                            icon: "el-icon-menu",
                            id: "202",
                            isNav: true,
                            component: Nav,
                            children: [
                                {
                                    path: "/rqwxjl",
                                    name: "rqwxjl",
                                    icon: "el-icon-menu",
                                    id: "146",
                                    title: "维修记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/rqwxjl.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/ylgdjy",
                                    name: "ylgdjy",
                                    icon: "el-icon-menu",
                                    id: "148",
                                    title: "压力管道检验记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/ylgdjy.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/asstopRecord",
                                    name: "asstopRecord",
                                    icon: "el-icon-menu",
                                    id: "182",
                                    title: "停气记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/asstopRecord.vue",
                                        ], resolve),
                                },
                            ],
                        },

                        {
                            path: "/enterpriseOperationData",
                            name: "enterpriseOperationData",
                            title: "企业运营数据",
                            icon: "el-icon-menu",
                            id: "203",
                            isNav: true,
                            component: (resolve) =>
                                require([
                                    "@/views/enterpriseOperationData/index.vue",
                                ], resolve),
                        },
                        {
                            path: "/GSA",
                            name: "GSA",
                            icon: "el-icon-c-scale-to-original",
                            id: "62",
                            title: "供气量台账",
                            component: Nav,
                            children: [
                                {
                                    path: "/pipelineNaturalgasaccount",
                                    name: "pipelineNaturalgasaccount",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "67",
                                    title: "管道天然气台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/pipelineNaturalgasaccount.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/standingBookofLPG",
                                    name: "standingBookofLPG",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "68",
                                    title: "液化石油气台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/standingBookofLPG.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: '/manualgasaccount',
                                //     name: 'manualgasaccount',
                                //     icon: 'el-icon-c-scale-to-original',
                                //     id:'69',
                                //     title:'人工煤气台账',
                                //     component: resolve => require(["../components/dy/manualgasaccount.vue"], resolve),
                                // },
                                {
                                    path: "/ngfpa",
                                    name: "ngfpa",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "70",
                                    title: "天然气加气站台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/ngfpa.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/AGPAGSF",
                            name: "AGPAGSF",
                            icon: "el-icon-c-scale-to-original",
                            id: "63",
                            title: "购气量及储气设施台账",
                            component: Nav,
                            children: [
                                {
                                    path: "/sbogpv",
                                    name: "sbogpv",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "71",
                                    title: "购气量台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/sbogpv.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/sbogsf",
                                    name: "sbogsf",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "72",
                                    title: "储气设施台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/sbogsf.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/enterpriseInformation",
                            name: "enterpriseInformation",
                            icon: "el-icon-c-scale-to-original",
                            id: "61",
                            title: "企业信息台账",
                            component: Nav,
                            children: [
                                {
                                    path: "/enterpriseInformationLedger",
                                    name: "enterpriseInformationLedger",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "65",
                                    title: "企业信息台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/enterpriseInformationLedger.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/enterprisePersonnelaccount",
                                    name: "enterprisePersonnelaccount",
                                    icon: "el-icon-c-scale-to-original",
                                    id: "164",
                                    title: "从业人员台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/employees.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/AONRGU",
                                    name: "AONRGU",
                                    icon: "el-icon-menu",
                                    id: "64",
                                    title: "非居民燃气用户台账",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/submitRecords/fjmrqyh.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: '/employeeManagement',
                                //     name: 'employeeManagement',
                                //     icon: 'el-icon-menu',
                                //     id: '164',
                                //     title: '从业人员管理',
                                //     component: resolve => require(['../views/employeeManagement'], resolve)
                                // },
                            ],
                        },
                        {
                            path: "/comprehensiveEvaluation",
                            name: "comprehensiveEvaluation",
                            title: "企业综合评价",
                            icon: "el-icon-menu",
                            id: "100",
                            component: Nav,
                            children: [
                                {
                                    path: "/manager",
                                    name: "manage",
                                    icon: "el-icon-menu",
                                    id: "101",
                                    title: "评价指标管理",
                                    // conponent: resolve => require(['../views/steelCylinderBasicMangement/steelCylinderManagement/index.vue'], resolve)
                                    component: (resolve) =>
                                        require([
                                            "../views/companyEvaluate/manage/index",
                                        ], resolve),
                                },
                                {
                                    path: "/model",
                                    name: "EvaluateModel",
                                    icon: "el-icon-menu",
                                    id: "102",
                                    title: "评价模型管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/companyEvaluate/EvaluateModel/index",
                                        ], resolve),
                                },
                                {
                                    path: "/scoring",
                                    name: "EvaluationScoring",
                                    icon: "el-icon-menu",
                                    id: "103",
                                    title: "综合评价打分",
                                    component: (resolve) =>
                                        require([
                                            "../views/companyEvaluate/EvaluationScoring/index",
                                        ], resolve),
                                },
                                {
                                    path: "/display",
                                    name: "EvaluateDisplay",
                                    icon: "el-icon-menu",
                                    id: "104",
                                    title: "综合评价展示",
                                    component: (resolve) =>
                                        require([
                                            "../views/companyEvaluate/EvaluateDisplay/index",
                                        ], resolve),
                                },
                                {
                                    path: "/analyse",
                                    name: "EvaluateAnalyse",
                                    icon: "el-icon-menu",
                                    id: "105",
                                    title: "综合评价分析",
                                    component: (resolve) =>
                                        require([
                                            "../views/companyEvaluate/EvaluateAnalyse/index",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/riskAssessment",
                            name: "riskAssessment",
                            title: "风险评估",
                            icon: "el-icon-menu",
                            id: "186",
                            component: Nav,
                            children: [
                                {
                                    path: "/riskIndicate",
                                    name: "riskIndicate",
                                    icon: "el-icon-menu",
                                    id: "189",
                                    title: "安全风险评估指标管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/riskAssessment/riskIndicate/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/riskModel",
                                    name: "riskModel",
                                    icon: "el-icon-menu",
                                    id: "190",
                                    title: "安全风险评估模型管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/riskAssessment/riskModel/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/coefficient",
                                    name: "coefficient",
                                    icon: "el-icon-menu",
                                    id: "198",
                                    title: "规模系数管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/riskAssessment/riskCoefficient/index",
                                        ], resolve),
                                },
                                {
                                    path: "/enterpriseRisk",
                                    name: "enterpriseRisk",
                                    icon: "el-icon-menu",
                                    id: "187",
                                    title: "企业安全风险评估",
                                    component: (resolve) =>
                                        require([
                                            "../views/riskAssessment/enterpriseRisk/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/regionRisk",
                                    name: "regionRisk",
                                    icon: "el-icon-menu",
                                    id: "188",
                                    title: "行政区划风险评估",
                                    component: (resolve) =>
                                        require([
                                            "../views/riskAssessment/regionRisk/index.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/Info",
                            name: "Info",
                            icon: "el-icon-menu",
                            id: "38",
                            isnav: true,
                            title: "信息管理",
                            component: Nav,
                            children: [
                                {
                                    path: "/station",
                                    name: "station",
                                    icon: "el-icon-menu",
                                    id: "40",
                                    title: "场站",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/station.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/pressDevice",
                                    name: "PressDevice",
                                    icon: "el-icon-menu",
                                    id: "136",
                                    title: "调压柜/调压箱",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/pressDevice.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/gasStorage",
                                    name: "gasStorage",
                                    icon: "el-icon-menu",
                                    id: "47",
                                    title: "储气罐设施",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/gasStorage.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/pipeline",
                                    name: "pipeline",
                                    icon: "el-icon-menu",
                                    id: "41",
                                    title: "管线",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/pipeline.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/pipepoint",
                                    name: "pipepoint",
                                    icon: "el-icon-menu",
                                    id: "45",
                                    title: "管点",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/pipepoint.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/wellchamber",
                                    name: "wellchamber",
                                    icon: "el-icon-menu",
                                    id: "42",
                                    title: "井室",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/wellchamber.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/adjacentspace",
                                    name: "adjacentspace",
                                    icon: "el-icon-menu",
                                    id: "43",
                                    title: "相邻空间",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/adjacentspace.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/densespace",
                                    name: "densespace",
                                    icon: "el-icon-menu",
                                    id: "44",
                                    title: "密集场所",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/densespace.vue",
                                        ], resolve),
                                },

                                {
                                    path: "/jcsbgl",
                                    name: "jcsbgl",
                                    icon: "el-icon-menu",
                                    id: "135",
                                    title: "监测设备",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/jcsbgl.vue",
                                        ], resolve),
                                },
                                // {
                                //     path: "/fjmrqyhgl",
                                //     name: "fjmrqyhgl",
                                //     icon: "el-icon-menu",
                                //     id: "125",
                                //     title: "非居民燃气用户管理",
                                //     component: (resolve) =>
                                //         require([
                                //             "../components/dy/Gas/fjmrqyhgl.vue",
                                //         ], resolve),
                                // },
                                {
                                    path: "/steelCylinderManagement",
                                    name: "steelCylinderManagement",
                                    icon: "el-icon-menu",
                                    id: "157",
                                    title: "钢瓶管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/steelCylinderBasicMangement/steelCylinderManagement",
                                        ], resolve),
                                },
                                {
                                    path: "/carManagement",
                                    name: "carManagement",
                                    icon: "el-icon-menu",
                                    id: "158",
                                    title: "车辆管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/steelCylinderBasicMangement/carManagement",
                                        ], resolve),
                                },
                                {
                                    path: "/rqwxdw",
                                    name: "rqwxdw",
                                    icon: "el-icon-menu",
                                    id: "144",
                                    title: "维修队伍",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/rqwxdw.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/news",
                                    name: "news",
                                    icon: "el-icon-menu",
                                    id: "163",
                                    title: "新闻资讯管理",
                                    component: (resolve) =>
                                        require(["../views/news"], resolve),
                                },
                                {
                                    path: "/lawsManagement",
                                    name: "lawsManagement",
                                    icon: "el-icon-menu",
                                    id: "173",
                                    title: "法律法规库管理",
                                    component: (resolve) =>
                                        require([
                                            "../views/news/lawsManagement",
                                        ], resolve),
                                },
                                {
                                    path: "/industry",
                                    name: "industry",
                                    title: "行业专家",
                                    icon: "el-icon-menu",
                                    id: "196",
                                    isNav: true,
                                    component: (resolve) =>
                                        require([
                                            "@/views/IndustryExperts/index.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/rqxjjl",
                                    name: "rqxjjl",
                                    icon: "el-icon-menu",
                                    id: "151",
                                    title: "巡线记录",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/rqxjjl.vue",
                                        ], resolve),
                                },

                                {
                                    path: "/rqxxzdgl",
                                    name: "rqxxzdgl",
                                    icon: "el-icon-menu",
                                    id: "149",
                                    title: "巡线制度管理",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/Gas/rqxxzdgl.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/residentGasUsers",
                            name: "residentGasUsers",
                            title: "应急管理",
                            icon: "el-icon-menu",
                            id: "84",
                            component: Nav,
                            children: [
                                {
                                    path: "/yjrqyzt",
                                    name: "yjrqyzt",
                                    title: "应急一张图",
                                    icon: "el-icon-menu",
                                    id: "123",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/yzt/yjrqyzt1.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjry",
                                    title: "应急人员",
                                    name: "yjry",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "86",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjry.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/dwjy",
                                    title: "救援队伍",
                                    name: "dwjy",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "87",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/dwjy.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjzj",
                                    title: "应急专家",
                                    name: "yjzj",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "88",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjzj.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjwz",
                                    title: "应急物资",
                                    name: "yjwz",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "89",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjwz.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/wzwz",
                                    title: "应急物资位置",
                                    name: "wzwz",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "90",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/wzwz.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/fhcs",
                                    title: "重点防护场所",
                                    name: "fhcs",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "91",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/fhcs.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/bhcs",
                                    title: "庇护场所",
                                    name: "bhcs",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "92",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/bhcs.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjya",
                                    title: "应急预案",
                                    name: "yjya",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "93",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjya.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjyl",
                                    title: "应急演练",
                                    name: "yjyl",
                                    icon: "el-icon-menu",
                                    isNav: true,
                                    id: "94",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjyl.vue",
                                        ], resolve),
                                },
                                {
                                    path: "/yjsj",
                                    title: "应急事件",
                                    name: "yjsj",
                                    icon: "el-icon-menu",
                                    id: "95",
                                    component: (resolve) =>
                                        require([
                                            "../components/dy/contingencyManagement001/yjsj.vue",
                                        ], resolve),
                                },
                            ],
                        },
                        {
                            path: "/comprehensivesummary1",
                            name: "comprehensivesummary1",
                            icon: "el-icon-c-scale-to-original",
                            id: "82",
                            title: "综合汇总",
                            component: (resolve) =>
                                require([
                                    "../components/dy/comprehensivesummary1.vue",
                                ], resolve),
                        },
                        {
                            path: "/oc",
                            name: "oc",
                            icon: "el-icon-menu",
                            id: "17",
                            title: "统筹协调",
                            component: (resolve) =>
                                require(["../components/dy/oc.vue"], resolve),
                        },
                        {
                            path: "/announcement",
                            name: "announcement",
                            icon: "el-icon-menu",
                            id: "195",
                            title: "公告管理",
                            component: (resolve) =>
                                require(["../views/announcement"], resolve),
                        },
                        // {
                        //     path: "/AONRGU",
                        //     name: "AONRGU",
                        //     icon: "el-icon-c-scale-to-original",
                        //     id: "64",
                        //     title: "非居民燃气用户台账",
                        //     component: Nav,
                        //     children: [
                        //         {
                        //             path: "/lsbonru",
                        //             name: "lsbonru",
                        //             icon: "el-icon-c-scale-to-original",
                        //             id: "73",
                        //             title: "非居民用户最新台账",
                        //             component: (resolve) =>
                        //                 require([
                        //                     "../components/dy/lsbonru.vue",
                        //                 ], resolve),
                        //         },
                        //         {
                        //             path: "/hsbonru",
                        //             name: "hsbonru",
                        //             icon: "el-icon-c-scale-to-original",
                        //             id: "74",
                        //             title: "非居民用户历史台账 ",
                        //             component: (resolve) =>
                        //                 require([
                        //                     "../components/dy/hsbonru.vue",
                        //                 ], resolve),
                        //         },
                        //     ],
                        // },

                        // {
                        //     path: '/monitor',
                        //     name: 'monitor',
                        //     icon: 'el-icon-menu',
                        //     id: '166',
                        //     title: '监控管理',
                        //     component: resolve => require(['../views/monitor'], resolve)
                        // },

                        // {
                        //     path: '/rqioc',
                        //     name: 'rqioc',
                        //     icon: 'el-icon-menu',
                        //     id:'5',
                        //     title:'智慧展示',
                        //     component:resolve => require(['../components/dy/rqioc.vue'], resolve)
                        // },
                    ],
                },
                {
                    path: "/settings",
                    name: "settings",
                    icon: "@/../static/img/dy/5.png",
                    iconEd: "@/../static/img/dy/9.png",
                    id: "4",
                    level: 1,
                    selected: false,
                    isnav: true,
                    component: Nav,
                    redirect: "/userManagement",
                    title: "系统设置",
                    children: [
                        {
                            path: "/userManagement",
                            name: "userManagement",
                            icon: "el-icon-menu",
                            id: "34",
                            title: "用户管理",
                            component: (resolve) =>
                                require(["../components/dy/user.vue"], resolve),
                        },
                        {
                            path: "/rolemanagement",
                            name: "rolemanagement",
                            icon: "el-icon-c-scale-to-original",
                            id: "6",
                            title: "系统登录日志",
                            component: (resolve) =>
                                require([
                                    "../components/dy/systemLoginLog.vue",
                                ], resolve),
                        },
                        {
                            path: "/permissionManagement",
                            name: "permissionManagement",
                            icon: "el-icon-c-scale-to-original",
                            id: "35",
                            title: "权限综合管理",
                            component: (resolve) =>
                                require([
                                    "../components/dy/power.vue",
                                ], resolve),
                        },
                        {
                            path: "/businessManagement",
                            name: "businessManagement",
                            icon: "el-icon-c-scale-to-original",
                            id: "36",
                            title: "企业管理",
                            component: (resolve) =>
                                require([
                                    "../components/dy/businessManagement.vue",
                                ], resolve),
                        },
                        {
                            path: "/enterpriseAccountManagement",
                            name: "enterpriseAccountManagement",
                            icon: "el-icon-c-scale-to-original",
                            id: "37",
                            title: "企业账户管理",
                            component: (resolve) =>
                                require([
                                    "../components/dy/enterpriseAccountManagement.vue",
                                ], resolve),
                        },
                        {
                            path: "/rolemanagement",
                            name: "rolemanagement",
                            icon: "el-icon-c-scale-to-original",
                            id: "55",
                            title: "应急参数",
                            component: (resolve) =>
                                require([
                                    "../components/dy/rolemanagement.vue",
                                ], resolve),
                        },
                    ],
                },

                // {
                //     path: "/power",
                //     icon: "iconfont icon-Cockpit",
                //     title: "",
                //     component: resolve => require(["../components/dy/power.vue"], resolve),
                //     isnav: true,
                // },
            ],
        },

        {
            path: "/login",
            icon: "iconfont icon-Cockpit",
            isnav: true,
            component: (resolve) =>
                require(["../components/dy/login.vue"], resolve),
        },
        {
            path: "/enterpriseAlarm",
            icon: "iconfont icon-Cockpit",
            isnav: true,
            component: (resolve) =>
                require(["@/views/homePage/enterpriseAlarmNotifi"], resolve),
        },
    ],
};

const router = new Router(myrouter);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js